import React, { useEffect, useState } from "react";
import LoadingPage from "./components/LoadingPage";
import "./App.css";
import BingoPage from "./components/BingoPage";
import { getTickets, ticketsProps } from "./components/apis/getTickets";
import PurchaseTicketsPage from "./components/PurchaseTicketsPage";
import {
  drawDetailsProps,
  getDrawDetail,
} from "./components/apis/getDrawDetail";
import CancelPop from "./components/popups/CancelPop";
import WinnersPopup from "./components/WinnerModal";
import { getUser, getZegoToken, UserProps } from "./components/apis/user";
import { handleNavigationTobackOffice } from "./components/utils/NavigateToBackOffice";
import ErrorPage from "./components/ErrorPage";
import ErrorBoundary from "./components/ErrorBoundary";
import { winnerList, winnerListProps } from "./components/apis/winner";
import useWebSocket from "./components/WebSocketManager";
import { Token } from "./components/urlParams";
import { WALLET_SOCKET_URL } from "./envVariables";
import { RemainingTimer } from "./components/Timer";
import PixiPage from "./components/PixiPage";
import BingoPixiApp from "./components/pixi-app";

export type pageRoutes =
  | "loadingPage"
  | "purchaseTicketPage"
  | "gamePage"
  | "errorPage";

export interface closeModalData {
  status: boolean;
  test?: string;
}
const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<pageRoutes>("loadingPage");
  const [ticketData, setTicketData] = useState<ticketsProps>();
  const [drawDetails, setDrawDetails] = useState<drawDetailsProps>();
  const [showWinners, setShowWinners] = useState<boolean>(false);
  const [closeModal, setCluseModal] = useState<closeModalData>({
    status: false,
    test: undefined,
  });
  const [drawTime, setDrawTime] = useState<string | Date | undefined>(
    undefined
  );
  const [cutoffTime, setCutoffTime] = useState<string | Date | undefined>(
    undefined
  );
  const [userWallet, setUserWallet] = useState<UserProps>();
  const [error, setError] = useState<Error | null>(null);
  const [userWalletAmount, setUserWalletAmount] = useState();
  const [zegoToken, setZegoToken] = useState(null);
  const [getTimer, setGetTimer] = useState<boolean>();

  useEffect(() => {
    if (!cutoffTime) return;

    const intervalId = setInterval(() => {
      const { timer, isExpired } = RemainingTimer(cutoffTime);
      setGetTimer(isExpired);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [cutoffTime]);

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const data = await getTickets();
        setTicketData(data);
      } catch (error) { }
    };
    fetchTickets();
  }, [currentPage]);

  useEffect(() => {
    const drawDetails = async () => {
      try {
        const data = await getDrawDetail();
        const user = await getUser();
        const token = await getZegoToken(data?.draw?.id);
        setZegoToken(token);
        setUserWallet(user);
        setDrawDetails(data);
        setDrawTime(data?.draw?.drawTime);
        setCutoffTime(data?.draw.cutoffTime);
      } catch (error) { }
    };
    drawDetails();
  }, []);

  const handleNextPage = (nextPage: pageRoutes) => {
    setCurrentPage(nextPage);
  };

  const handleBally = (numbers: number[]) => { };

  const drawStatus =
    drawDetails?.draw &&
    (drawDetails.draw.status === 2 || drawDetails.draw.status === 3);

  useEffect(() => {
    if (currentPage === "loadingPage") {
      const timer = setTimeout(() => {
        if (drawStatus) {
          handleNavigationTobackOffice();
        } else if (ticketData && ticketData.count > 0 && getTimer) {
          setCurrentPage("gamePage");
        } else if (ticketData && ticketData.count < 4 && !getTimer) {
          setCurrentPage("purchaseTicketPage");
        } else {
          setCurrentPage("purchaseTicketPage");
        }
      }, 4000);
      return () => clearTimeout(timer);
    }
    if (ticketData) {
      if (getTimer) {
        if (ticketData.count > 0 && currentPage !== "gamePage") {
          setCurrentPage("gamePage");
        }
      } else if (ticketData.count >= 4) {
        setCurrentPage("gamePage");
      }
    }
  }, [currentPage, drawStatus, getTimer, ticketData]);

  const handleTicketPurchase = () => {
    setCurrentPage("gamePage");
  };

  const handleCloseModal = (data: closeModalData) => {
    setCluseModal({ status: data.status, test: data.test });
  };
  const handleShowWinnersModal = (status: boolean) => {
    setShowWinners(status);
  };
  const handleRetry = () => {
    setError(null);
    setCurrentPage("loadingPage");
  };
  const handleWalletSocket = (data: any) => {
    setUserWalletAmount(data);
  };

  useWebSocket(
    WALLET_SOCKET_URL,
    "wallet",
    handleWalletSocket,
    true,
    Token,
    "/api/socket",
    showWinners
  );
  const renderPage = () => {
    switch (currentPage) {
      case "loadingPage":
        return <LoadingPage />;
      case "gamePage":
        return (
          <BingoPage
            zegoToken={zegoToken}
            userWalletAmount={userWalletAmount}
            userWallet={userWallet}
            handleShowWinnersModal={handleShowWinnersModal}
            handleCloseModal={handleCloseModal}
            ticketData={ticketData}
            drawDetails={drawDetails}
            handleBally={handleBally}
            showWinners={showWinners}
            drawTime={drawTime}
          />
        );
      case "purchaseTicketPage":
        return (
          <PurchaseTicketsPage
            setCurrentPage={setCurrentPage}
            drawDetails={drawDetails}
            onTicketPurchase={handleTicketPurchase}
            time={cutoffTime}
            userWallet={userWallet}
            handleCloseModal={handleCloseModal}
            ticketData={ticketData}
            getTimer={getTimer}
          />
        );
      case "errorPage":
        return <ErrorPage onRetry={handleRetry} />;
      default:
        return <LoadingPage />;
    }
  };

  return (
    <ErrorBoundary onReset={handleRetry}>
      <div className="app  relative w-full h-screen">
        <div className={`w-full fixed top-0 left-0 h-full ${currentPage === "gamePage" ? "block" : "hidden"}`}>
          <BingoPixiApp />
        </div>

        <div
          className={`w-full relative `}
        >
          {renderPage()}
        </div>

        <div>
          {showWinners && (
            <WinnersPopup
              showWinners={showWinners}
              onClose={() => handleNavigationTobackOffice()}
            />
          )}
          {closeModal.status && !showWinners && (
            <CancelPop
              closeModal={closeModal}
              onClose={() => handleNavigationTobackOffice()}
            />
          )}
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default App;
